import { useEffect, useState } from "react"

import { SignIn } from "@clerk/nextjs"
import type { SignInResource } from "@clerk/shared/types"
import { Loader } from "@coval/ui"

interface Props {
  status: SignInResource["status"] | undefined
  redirectUrlComplete: string
  signUpHref: string
}

export function ClerkSecondFactorFallback({
  status,
  redirectUrlComplete,
  signUpHref,
}: Props) {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    if (ready) {
      return
    }
    // Clerk's hash router must start at the pending verification step, preserving the current page's handoff query.
    if (
      !window.location.hash.startsWith("#/") ||
      window.location.hash === "#/"
    ) {
      if (status === "needs_second_factor") {
        window.history.replaceState(window.history.state, "", "#/factor-two")
      } else if (status === "needs_client_trust") {
        window.history.replaceState(window.history.state, "", "#/client-trust")
      }
    }
    setReady(true)
  }, [ready, status])
  if (!ready) {
    return <Loader label="Loading verification" />
  }
  return (
    <SignIn
      routing="hash"
      forceRedirectUrl={redirectUrlComplete}
      signUpUrl={signUpHref}
      appearance={{
        elements: {
          rootBox: "w-full",
          cardBox: "w-full",
          card: "w-full max-w-full shadow-none",
        },
      }}
    />
  )
}
